module.exports = __webpack_public_path__ + "img/detallecurso3.12089585.png";